<template>
  <v-parallax :src="assets.backgrounds.firecamp_background" height="100%">
    <div
         class="bgggrupos d-flex flex-column fill-height justify-center align-center text-white">
      <div class="loginCard pa-7">
        <v-form v-if="authStep == 0" :submit="login">
          <v-row>
            <v-col cols="12">
              <v-text-field
                :disabled="requestingApi"
                v-model="form.email"
                :rules="rules.email"
                label="E-mail"
                variant="solo"
                            prepend-inner-icon="mdi-mail"></v-text-field>
              <v-text-field
                :disabled="requestingApi"
                v-model="form.password"
                :rules="rules.password"
                label="Senha"
                variant="solo"
                :type="showPassword ? 'text' : 'password'"
                prepend-inner-icon="mdi-eye"
                            @click:prepend-inner="showPassword = !showPassword"></v-text-field>
            </v-col>
            <v-col cols="6">
              <span class="fakeLink subheading" @click="authStep = 2">Esqueci minha senha</span>
              <!-- <br/>
              <span class="fakeLink subheading">Primeiro acesso</span> -->
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                :disabled="requestingApi"
                color="white"
                class="px-10"
                variant="outlined"
                :rounded="1"
                     type="submit">Login</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <!-- esqueci minha senha -->
        <v-form :submit="requestResetPassword" v-if="authStep == 2">
          <v-row>
            <v-col cols="12">
              <v-text-field
                :disabled="requestingApi"
                v-model="form.email"
                :rules="rules.email"
                label="E-mail"
                            variant="solo"></v-text-field>
              <p class="text-center">
                Insira seu e-mail e clique em enviar para receber um e-mail com
                um código de verificação para alterar sua senha
              </p>
            </v-col>
            <v-col cols="6">
              <span class="fakeLink subheading" @click="authStep = 0">Login</span>
              <!-- <br/>
              <span class="fakeLink subheading">Primeiro acesso</span> -->
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                :disabled="requestingApi"
                color="white"
                class="px-10"
                variant="outlined"
                :rounded="1"
                     type="submit">Enviar</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-form ref="formOTP" :submit="resetPassword" v-if="authStep == 3">
          <v-row>
            <v-col cols="12">
              <v-text-field
                            :disabled="requestingApi"
                            v-model="form.email"
                            :rules="rules.email"
                            label="E-mail"
                            variant="solo"></v-text-field>
              <v-text-field
                            :disabled="requestingApi"
                            v-model="form.password"
                            :rules="rules.password"
                            label="Nova senha"
                            variant="solo"
                            :type="showPassword ? 'text' : 'password'"
                            prepend-inner-icon="mdi-eye"
                            @click:prepend-inner="showPassword = !showPassword"></v-text-field>
              <v-text-field
                            :disabled="requestingApi"
                            v-model="form.password2"
                            :rules="rules.password2"
                            label="Repita sua nova senha"
                            variant="solo"
                            :type="showPassword ? 'text' : 'password'"
                            prepend-inner-icon="mdi-eye"
                            @click:prepend-inner="showPassword = !showPassword"></v-text-field>
              <VOtpInput
                         v-model="form.otp"
                         input-classes="otp-input"
                         input-type="number"
                         inputmode="numeric"
                         separator=""
                         :is-disabled="requestingApi"
                         :num-inputs="6"
                         :should-auto-focus="true"
                         :placeholder="'0,0,0,0,0,0'"
                         @on-change="onChangeOTP"
                         @on-complete="onCompleteOTP" />
              <p class="text-center">
                Verifique seu e-mail, enviamos um código para alterar a senha
              </p>
            </v-col>
            <v-col cols="12" v-if="requestingApi">
              <v-progress-linear
                                 indeterminate
                                 color="yellow-darken-2"></v-progress-linear>
            </v-col>
            <v-col cols="6">
              <span class="fakeLink subheading" @click="authStep = 0">Login</span>
              <!-- <br/>
              <span class="fakeLink subheading">Primeiro acesso</span> -->
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                     :disabled="requestingApi"
                     color="white"
                     class="px-10"
                     variant="outlined"
                     :rounded="1"
                     type="submit">Alterar senha</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>
      <PdvApkDownload class="mt-5 text-white" />
      <Copyright class="mt-5" />
      <p class="text-body-2">
        Dúvidas e Informações: <v-icon>mdi-mail</v-icon>
        <a style="color: white" href="mailto:faleconosco@ggrupos.com.br">faleconosco@ggrupos.com.br</a>
      </p>
    </div>
  </v-parallax>
</template>
<style>
.loginCard {
  width: 100%;
  max-width: 500px;
  border: 1px solid white;
  border-radius: 10px;
}

.bgggrupos {
  background-color: rgba(23, 162, 184, 0.8);
}
</style>
<script>
import assets from "@/assets/assets";
import Copyright from "../components/Copyright.vue";
import PdvApkDownload from "../components/PdvApkDownload.vue";
import VOtpInput from "vue3-otp-input";
import api from '@/services'
export default {
  components: { Copyright, PdvApkDownload, VOtpInput },
  props: {},
  data() {
    return {
      requestingApi: false,
      assets: assets,
      authStep: 0,
      showPassword: false,
      form: {
        email: "",
        password: "",
        otp: null,
      },
      rules: {
        email: [
          (v) => !!v || "Este campo é obrigatório",
          (v) => /.+@.+/.test(v) || "Coloque um e-mail válido",
        ],
        password: [
          (v) => !!v || "Este campo é obrigatório",
          (value) => {
            // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
            const pattern = /^(?=.{8,})/;
            return pattern.test(value) || "Coloque uma senha válida";
          },
        ],
        password2: [
          (v) => !!v || "Este campo é obrigatório",
          (value) => {
            // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
            const pattern = /^(?=.{8,})/;
            return pattern.test(value) || "Coloque uma senha válida";
          },
          (value) => {
            return (
              value == this.form.password || "As senhas precisam ser iguais"
            );
          },
        ],
      },
    };
  },
  mounted() { },
  activated() { },
  methods: {
    onChangeOTP(val) {
      var vm = this;

      vm.form.otp = val;
      console.log(val, vm.form.otp);
    },
    async onCompleteOTP(val) {
      var vm = this;
      vm.form.otp = val;
      const { valid } = await this.$refs.formOTP.validate();
      if (valid) {
        vm.resetPassword();
      }
    },
    resetPassword() {
      var vm = this;
      if (vm.form.otp && vm.form.otp.length == 6) {
        vm.requestingApi = true;
        api.auth
          .resetPassword(vm.form.email, vm.form.password, vm.form.otp)
          .then((result) => {
            vm.$notify({
              type: "info",
              text: "Senha alterada com sucesso",
            });
            vm.authStep = 0
          })
          .catch((error) => {
            let _msg = error.message;
            try {
              if (error?.response?.status == 404) {
                _msg = "Nenhum usuário encontrado com este e-mail";
              }
            } catch (err2) {
              // do nothing
            }

            try {
              if (error?.response?.status == 403) {
                _msg = "Requisição inválida";
              }
            } catch (err2) {
              // do nothing
            }

            try {
              if (error?.response?.status == 415) {
                _msg = "A senha deve conter pelo menos 8 caracteres.";
              }
            } catch (err2) {
              // do nothing
            }

            try {
              if (error?.response?.status == 402) {
                _msg = "Código de validação inválido!";
              }
            } catch (err2) {
              // do nothing
            }
            vm.$notify({ type: "warn", text: _msg });
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      } else {
        console.debug(vm.form.otp);
        vm.$notify({
          type: "warn",
          text: "Código inválido",
        });
      }
    },
    requestResetPassword() {
      var vm = this;
      vm.requestingApi = true;
      api.auth
        .resetPasswordRequest(vm.form.email)
        .then((result) => {
          vm.$notify({
            type: "info",
            text: "E-mail enviado. Verifique o código de confirmação",
          });
          vm.authStep += 1;
        })
        .catch((error) => {
          let _msg = error.message;
          try {
            if (error?.response?.status == 404) {
              _msg = "Nenhum usuário encontrado com este e-mail";
            }
          } catch (err2) {
            // do nothing
          }

          try {
            if (error?.response?.status == 403) {
              _msg = "Requisição inválida";
            }
          } catch (err2) {
            // do nothing
          }

          vm.$notify({ type: "warn", text: _msg });
        })
        .finally(() => {
          vm.requestingApi = false;
        });
    },
    login() {
      var vm = this;
      vm.requestingApi = true;
      api.auth
        .login(vm.form.email, vm.form.password)
        .then((result) => {
          vm.$emit("loggedIn", result);
          vm.$router.push({ name: "Home" });
        })
        .catch((error) => {
          try {
            if (error?.response?.status == 406) {
              vm.$notify({
                type: "warn",
                text: "E-mail não verificado",
              });
              vm.authStep = 4;
              return;
            }
          } catch (err2) {
            // do nothing
          }
          vm.$notify({ type: "error", text: error?.response?.data?.message.replace(/^\[BR\]/g, '').replace(/^\[EN\]/g, 'TRADUIZDO: ') });
        })
        .finally(() => {
          vm.requestingApi = false;
        });
    },
  },
  computed: {},
};
</script>